import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import '../css/PersonalDetails.css';

class PersonalDetails extends Component{
    constructor(props){
        super(props)
    }

    render(){
        const {t} = this.props
        let gender = ''
        if (this.props.member.gender && this.props.member.gender == 'M'){
            gender = 'Male'
        }else if (this.props.member.gender && this.props.member.gender == 'M'){
            gender = 'Female'
        }

        return(
            <div>
                <h1 className="balanceByAccount">My Details</h1>
                <table className="personalDetails" style={{ tableLayout: 'fixed', width: '100%' }}>
                    <tbody>
                        <tr>
                            <td>
                                <table style={{ tableLayout: 'fixed', width: '100%' }}>
                                    <th>
                                         <td colSpan={2}>
                                            Personal Details:
                                        </td>
                                    </th>
                                    <tr>
                                        <td>Name:</td>
                                        <td>{this.props.member.firstName} {this.props.member.lastName}</td>
                                    </tr>
                                    <tr>
                                        <td>Preferred Name:</td>
                                        <td>{this.props.member.preferredName}</td>
                                    </tr>
                                    <tr>
                                        <td>Gender:</td>
                                        {/* <td>{this.props.member.gender}</td> */}
                                        <td>{gender}</td>
                                    </tr>
                                    {this.props.member.resiAddr && Array.isArray(this.props.member.resiAddr)&& this.props.member.resiAddr.length >0 ?
                                        this.props.member.resiAddr.map((addrLine,index) => <tr>
                                            {index==0?<td>Residential Address:</td>:<td></td>}
                                            <td>{addrLine}</td> 
                                        </tr>)
                                        :<></>
                                    }
                                    <tr>
                                        <td>Email Address:</td>
                                        <td>{this.props.member.email}</td>
                                    </tr>
                                    <tr>
                                        <td>Phone:</td>
                                        <td>{this.props.member.phone}</td>
                                    </tr>
                                    <tr>
                                        <td>Mobile Number:</td>
                                        <td>{this.props.member.mobile}</td>
                                    </tr>
                                </table>
                            </td>
                            <td style={{ verticalAlign: 'top' }}>
                                <table style={{ tableLayout: 'fixed', width: '100%' }}>
                                    <th>
                                        <td ><p></p></td>
                                    </th>
                                    <tr>
                                        <td ><p></p></td>
                                    </tr>
                                    <tr>
                                        <td ><p></p></td>
                                    </tr>
                                    <tr>
                                        <td>Date of birth:</td>
                                        <td>{this.props.member.dob}</td>
                                    </tr>
                                    {this.props.member.postalAddr && Array.isArray(this.props.member.postalAddr)&& this.props.member.postalAddr.length >0 ?
                                        this.props.member.postalAddr.map((addrLine,index) => <tr>
                                            {index==0?<td>Postal Address:</td>:<td></td>}
                                            <td>{addrLine}</td> 
                                        </tr>)
                                        :<></>
                                    }
                                </table>
                            </td>
                        </tr>
                        <br></br>
                        <tr>
                            <td>
                                <table style={{ tableLayout: 'fixed', width: '100%' }}>
                                    <th>
                                        <td colSpan={2}>Membership Details:</td>
                                    </th>
                                    <tr>
                                        <td>IRD Number:</td>
                                        <td>{this.props.member.irdNumber}</td>
                                    </tr>
                                    <tr>
                                        <td>PIR Rate:</td>
                                        <td>{Number(this.props.member.pirRate).toFixed(1) + "%"}</td>
                                    </tr>
                                    {this.props.member.datePirLastChanged ?(
                                    <tr>
                                        <td>Date last PIR rate changed:</td>
                                        <td>{this.props.member.datePirLastChanged}</td>
                                    </tr>):<></>}
                                    <tr>
                                        <td>Date joined SuperLife:</td>
                                        <td>{this.props.member.dateJoinedSL}</td>
                                    </tr>
                                    <tr>
                                        <td>Date joined SuperLife for KiwiSaver:</td>
                                        <td>{this.props.member.dateJoinedKS}</td>
                                    </tr>
                                </table>
                            </td>
                            <td style={{ verticalAlign: 'top' }}>
                                <table style={{ tableLayout: 'fixed', width: '100%' }}>
                                    <th>
                                        <td ><p></p></td>
                                    </th>
                                    
                                    {this.props.member.memberNumber ?(<tr>
                                        <td>SL Number:</td>
                                        <td>{this.props.member.memberNumber}</td>
                                    </tr>):<tr> <td ><p></p></td></tr>}
                                    <tr>
                                        <td>Contribution Rate:</td>
                                        <td>{this.props.member.contribRate && Number(this.props.member.contribRate).toFixed(1) + "%"}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
        )
    }
}
export default PersonalDetails;